<template>
    <v-dialog v-model="$store.state.paperworkAnalytics.showPaperworkAnalyticsPanel" fullscreen persistent
        transition="dialog-transition">
        <v-toolbar dense dark color="secondary" class="white--text">
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Paperwork Analytics Panel
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon left @click="closePaperworkAnalyticsPanel">
                <v-icon>
                    mdi-window-close
                </v-icon>
            </v-btn>
        </v-toolbar>
        <v-card style="height: 80vh; background-color: #fff;">
            <v-container fluid>
                <div style="height: 50vh; background-color: #fff;">
                    <v-data-iterator :items="OrdersNotReviewed" :page="pageOrders" :items-per-page="1" hide-default-footer>
                        <template v-slot:default="props">
                            <div v-for="(itm, idx) in props.items" :key="'ord' + idx" style="height:100vh;">
                                <v-row>
                                    <v-col cols="4">
                                        <v-toolbar dense dark flat height="35" color="secondary" class="white--text">
                                            <v-spacer></v-spacer>
                                            <v-toolbar-title style="font-size: large;">
                                                BOL Quantities
                                            </v-toolbar-title>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                        <v-simple-table dense height="200px">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">
                                                            Product
                                                        </th>
                                                        <th class="text-left">
                                                            Product Code
                                                        </th>
                                                        <th class="text-left">
                                                            BOL Number
                                                        </th>
                                                        <th class="text-left">
                                                            Dispatched Quantity
                                                        </th>
                                                        <th class="text-left">
                                                            Gross Quantity
                                                        </th>
                                                        <th class="text-left">
                                                            Net Quantity
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(prd, i) in itm.eleos_data" :key="i">
                                                        <td>{{ prd.Product }}</td>
                                                        <td>{{ prd.ProductCode }}</td>
                                                        <td>{{ prd.BOLNumber }}</td>
                                                        <td><v-text-field
                                                            v-model="prd.DispatchedQuantity"
                                                            hide-details
                                                            dense
                                                            @change="updateQuantitys(prd)"
                                                        ></v-text-field></td>
                                                        <td>{{ prd.GrossQuantity }}</td>
                                                        <td>{{ prd.NetQuantity }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3" class="text-right"><strong>Totals</strong></td>
                                                        <td><strong>{{ itm.TotalDQ }}</strong></td>
                                                        <td><strong>{{ itm.TotalGQ }}</strong></td>
                                                        <td><strong>{{ itm.TotalNQ }}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <div style="margin: 20px 0 0 10px;">
                                            <p style="margin: 0;">
                                                <strong>Order: </strong>
                                                {{ itm.OrderID }}
                                            </p>
                                            <p style="margin: 0;">
                                                <strong>Customer: </strong>
                                                {{ itm.CustomerName }}
                                            </p>
                                            <v-simple-table class="mt-5">
                                                <tr>
                                                    <td class="pl-3"><strong>Terminal Start</strong></td>
                                                    <td class="pl-3"><strong>Station Start</strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="pl-3">{{ itm.TStart }}</td>
                                                    <td class="pl-3">{{ itm.StStart }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="pl-3"><strong>Terminal </strong></td>
                                                    <td class="pl-3"><strong>Station </strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="pl-3">{{ itm.TEnd }}</td>
                                                    <td class="pl-3">{{ itm.StEnd }}</td>
                                                </tr>
                                            </v-simple-table>
                                        </div>
                                        
                                        <v-toolbar dense dark flat height="35" color="secondary" class="white--text">
                                            <v-spacer></v-spacer>
                                            <v-toolbar-title style="font-size: large;">
                                                Actions
                                            </v-toolbar-title>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                        <div style="display: flex;justify-content: space-around;padding-top: 20px;">
                                            <div>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" color="success" small dark
                                                            @click="sendToVerifiedOrders(itm.OrderID)">
                                                            <v-icon>mdi-check-decagram-outline</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Send To Verified Orders</span>
                                                </v-tooltip>
                                            </div>
                                            <div>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" color="#e6b800" small dark
                                                            @click="openActionReasonModal(itm.OrderID, 2)">
                                                            <v-icon>mdi-newspaper-variant-outline</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Send To BOL Cleared</span>
                                                </v-tooltip>
                                            </div>
                                            <div>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" color="error" small dark
                                                            @click="openActionReasonModal(itm.OrderID, 3)">
                                                            <v-icon>mdi-alert-decagram-outline</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Send To Not Verified Orders</span>
                                                </v-tooltip>
                                            </div>
                                        </div>
                                        
                                    <v-pagination v-model="pageOrders" :total-visible="7" class="mt-6" :length="OrdersNotReviewed.length"
                                        prev-icon="mdi-menu-left" next-icon="mdi-menu-right"></v-pagination>
                                    </v-col>
                                    <v-col cols="8">
                                        <div style="height: 70vh; background-color: #fff;">
                                            <v-toolbar dense dark flat height="35" color="secondary" class="white--text">
                                                <v-spacer></v-spacer>
                                                <v-toolbar-title style="font-size: large;">
                                                    Document Viewer
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-data-iterator :items="itm.document" :page="page" :items-per-page="1"
                                                hide-default-footer>
                                                <template v-slot:default="props2">
                                                    <v-container v-for="(it, id) in props2.items" :key="'document' + id"
                                                        style="background-color: #fff;" fluid>
                                                        <iframe :src="it.Link" style="width: 100%; height:70vh ;"></iframe>
                                                        <v-pagination v-model="page" :length="itm.document.length"
                                                            prev-icon="mdi-menu-left"
                                                            next-icon="mdi-menu-right"></v-pagination>
                                                    </v-container>
                                                </template>
                                            </v-data-iterator>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>
                    </v-data-iterator>
                </div>
            </v-container>
            <!-- <v-container v-else>
                <v-row>
                    <div style="height: 70vh;background-color: #fff;margin: 0 auto;display: flex;align-items: center;">
                        <div style="padding-right: 35px;">
                            <v-alert
                                dense
                                prominent
                                type="success"
                            >
                                <strong>No orders to review!</strong>
                            </v-alert>
                        </div>
                    </div>
                </v-row>
            </v-container> -->
        </v-card>
        <action v-if="$store.state.paperworkAnalytics.action" :OrderID="OrderID" :Actions="actions"
            :BolCheckStatus="BolCheckStatus"  @closeAct="saveActions"></action>
    </v-dialog>
</template>
<script>
import axios from 'axios';


import action from './ActionReason.vue';

export default {
    props: ['OrdersNotReviewed', 'FromEleosCheck', 'OrderID'],
    components: {
        action
    },
    data: function () {
        return {
            page: 1,
            pageOrders: 1,
            order: 1,
            actions: [],
            BolCheckStatus: null,
        }
    },
    mounted() {
        console.log(this.OrdersNotReviewed);
        this.getActions();
    },
    methods: {
        getActions: function () {
            var str = this.$store;
            axios
                .get('action/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.actions = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        sendToVerifiedOrders: async function (orderID) {
            var str = this.$store;
            console.log("sendToVerifiedOrders");
            console.log(orderID);
            var parms = {
                BolCheckStatusID: 1
            }
            this.$store.state.isLoading = true;
            await axios
                .put('order/' + orderID, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order successfully updated.'
                    });

                    if (this.FromEleosCheck) {
                        this.$store.state.paperworkAnalytics.showPaperworkAnalyticsPanel = false;
                        str.state.isLoading = false;
                    } else {
                        
                        this.pageOrders++;
                        str.state.isLoading = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        sendToNotVerifiedOrders: async function (orderID) {
            var str = this.$store;
            console.log("sendToNotVerifiedOrders");
            console.log(orderID);

            this.$store.state.isLoading = true;
            await axios
                .put('paperwork-analytics/not-verified-order/' + orderID, '', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order successfully updated.'
                    });

                    if (this.FromEleosCheck) {
                        this.$store.state.paperworkAnalytics.showPaperworkAnalyticsPanel = false;
                        str.state.isLoading = false;
                    } else {
                        // Remove the order locally
                        let idx = null;
                        for (let ord = 0; ord < this.OrdersNotReviewed.length; ord++) {
                            if (this.OrdersNotReviewed[ord].OrderID == orderID) {
                                idx = ord;
                                break;
                            }
                        }
                        this.OrdersNotReviewed.splice(idx, 1);
                        str.state.isLoading = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        closePaperworkAnalyticsPanel: function () {
            // console.log("closePaperworkAnalyticsPanel");
            if (this.FromEleosCheck) {
                this.$store.state.paperworkAnalytics.showPaperworkAnalyticsPanel = false;
            } else {
                this.$emit('close');
                this.$store.state.paperworkAnalytics.showPaperworkAnalyticsPanel = false;
            }

        },
        saveActions: function () {
            this.pageOrders++;
        },
        openActionReasonModal: function (orderID, BolCheckStatus) {
            this.BolCheckStatus = BolCheckStatus;
            this.OrderID = orderID;
            this.$store.state.paperworkAnalytics.action = true;
        }
    },
};
</script>

<style>
/* Styles here */
</style>